export const BUREAU_NAMES = {
  equifax: 'Equifax',
  experian: 'Experian',
  transunion: 'TransUnion',
}

export const bureauName = (bureau) => BUREAU_NAMES[bureau] || bureau

export const TITLE = 'Credit Scores'
export const LATEST_REPORT = 'Latest report:'
export const REPORT_DATES = 'Report dates:'

export const WHAT_TO_EXPECT = 'What to expect'

export const EXPECT_PARAGRAPHS = [
  'Credit scores often go down in the first months of a debt settlement program. While enrolled accounts are not being paid, creditors may report them as late, which usually lowers scores.',
  'How scores change after that depends on many things, including how and when each account is resolved and your other credit. No change in your score can be predicted or promised.',
  'Your program is debt settlement, not credit repair. Scores are shown for your information.',
]

export const fromReport = (date) => `From your report on ${date}`
export const FIRST_REPORT = 'First report:'
export const ON = 'on'
export const NO_SCORE_TITLE = 'No score on this report'
export const noScoreExplanation = (bureau, date) =>
  `${bureau} did not return a score on ${date}. This can happen when a credit file is frozen or locked, or has too little information to score. It does not mean a score of zero.`
export const lastScore = (bureau, score, date) => `Last ${bureau} score: ${score} on ${date}.`

export const SINGLE_REPORT_NOTE =
  'If another credit report is added to your file, your score history will show here. There is no fixed schedule.'

export const ALL_REPORTS = 'All reports'
export const REPORT_DATE = 'Report date'
export const NO_SCORE = 'No score'
export const NO_REPORT = '—'
export const MODEL_NOT_REPORTED = 'model not reported'

export const ABOUT_TITLE = 'About these scores'
export const ABOUT_FIRST =
  "A new score appears only when a credit report is added to your file. There is no fixed schedule, and you don't need to do anything."
export const ABOUT_LAST = 'The charts use the full score scale, from 300 to 850. Each point is one report.'
export const LENDERS_SENTENCE = 'Lenders may use other scoring models, so the score a lender sees can differ.'

export const joinModels = (models) => {
  if (models.length <= 1) return models.join('')
  return `${models.slice(0, -1).join(', ')} and ${models[models.length - 1]}`
}

export const aboutModels = (models, unreported = false) =>
  !unreported && models && models.length > 0 ? `These are ${joinModels(models)} scores. ${LENDERS_SENTENCE}` : LENDERS_SENTENCE

export const ADMIN_SUFFIX = '· client portal view'
export const SHOWN_LABEL = 'Shown in client portal'
export const shownText = (shown) => `${SHOWN_LABEL}: ${shown ? 'Yes' : 'No'}`
export const ADMIN_HELPER =
  'The client sees these cards, plus the "What to expect" note and the report table. A new score appears only after a re-fetch, and each re-fetch is a paid pull. Turn the switch off to hide credit scores from this client, for example if a report was pulled for the wrong person.'

export const chartLabel = (count) => `Credit score chart, ${count} reports`
